import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getSentryClient } from '../sentry';
var error = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_error) {
    var SentryClient;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return getSentryClient();
        case 3:
          SentryClient = _context.sent;
          if (SentryClient) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          SentryClient.withScope(function (scope) {
            // TODO bring in user, product and other meta data from the to be implmented state store
            // scope.setUser({ id: user?.id || UNKNOWN_TAG });
            // scope.setTag('product', primaryProduct || UNKNOWN_TAG);
            SentryClient.captureException(_error, scope);
          });
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          // When there was an error with Sentry, just output to console
          // eslint-disable-next-line no-console
          console.error(_context.t0);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  }));
  return function error(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var logger = {
  error: error
};